<template>
  <FiltersItem>
    <template #title>
      {{ $l('showresult.filter.sortingFilterTitle') }}
    </template>
    <template #content>
      <FiltersItemContent>
        <template #content>
          <BaseToggle
            :text="$l('showresult.filter.sortEmission')"
            :checked="checked"
            @update:checked="onToggle"
          />
        </template>
      </filtersitemcontent>
    </template>
  </FiltersItem>
</template>

<script setup>
import { EventDispatcher } from '@utils/toolbox';
const { urlVars, timestamp, sharedOrgIndex, defaultSorting: _defaultSorting } = js_params;
// Store the current sorting state
const currentSorting = urlVars?.sorting || _defaultSorting;

// Store the current sorting state
const sorting = ref(currentSorting);
const previousSorting = ref(_defaultSorting);

const checked = computed(() => sorting.value === 'emission');

EventDispatcher.addEventListener('updateFiltersSorting', (e) => {
	previousSorting.value = sorting.value;
	sorting.value = e;
});

function onToggle () {
	if (checked.value) {
		window.showresult.updateSorting(previousSorting.value);
	} else {
		window.showresult.updateSorting('emission');
	}
}
</script>
